import * as React from 'react'
export default class AddToDiscoSuccessIcon extends React.PureComponent<any> {
  render(): React.ReactElement<'svg'> {
    return (
      <svg height="66" width="66" viewBox="0 0 66 66">
        <path
          d="M32.5 0C14.56 0 0 14.56 0 32.5 0 50.44 14.56 65 32.5 65 50.44 65 65 50.44 65 32.5 65 14.56 50.44 0 32.5 0zM26 48.75L9.75 32.5l4.582-4.583L26 39.552l24.667-24.667L55.25 19.5 26 48.75z"
          fill="#32B57C"
          transform="translate(.5 .5)"
        />
        <defs>
          <path
            id="a"
            d="M32.5 0C14.56 0 0 14.56 0 32.5 0 50.44 14.56 65 32.5 65 50.44 65 65 50.44 65 32.5 65 14.56 50.44 0 32.5 0zM26 48.75L9.75 32.5l4.582-4.583L26 39.552l24.667-24.667L55.25 19.5 26 48.75z"
          />
        </defs>
      </svg>
    )
  }
}
